export function CloseTransparentCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10.0492 5.99922C10.0492 8.23597 8.23597 10.0492 5.99922 10.0492C3.76247 10.0492 1.94922 8.23597 1.94922 5.99922C1.94922 3.76247 3.76247 1.94922 5.99922 1.94922C8.23597 1.94922 10.0492 3.76247 10.0492 5.99922ZM5.75381 3.84462C5.22661 3.31742 4.37183 3.31742 3.84462 3.84462C3.31742 4.37183 3.31742 5.22661 3.84463 5.75381L4.09003 5.99922L3.84462 6.24462C3.31742 6.77183 3.31742 7.6266 3.84462 8.15381C4.37183 8.68102 5.22661 8.68102 5.75381 8.15381L5.99922 7.90841L6.24463 8.15381C6.77183 8.68102 7.62661 8.68102 8.15381 8.15381C8.68102 7.62661 8.68102 6.77183 8.15381 6.24462L7.90841 5.99922L8.15381 5.75381C8.68102 5.22661 8.68102 4.37183 8.15381 3.84462C7.62661 3.31742 6.77183 3.31742 6.24462 3.84463L5.99922 4.09003L5.75381 3.84462Z'
        fill='white'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  )
}
